import * as React from "react";
import { DISTRIBUTION_POOLS_KEY, SEARCH_VIEW_ADJUSTMENTS } from "../../Consts";

export interface IPaginationViewProps {
    contentsLength: number;
    resultsPerPage: number;
    currentPage: any;
    updateContentsTable: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: any, repertoireSection: string) => void;
    repertoireSection?: string;
    componentInstance?: string;
    totalResults?: number;
    paginationData?: any;
}

export default class PaginationView extends React.Component<IPaginationViewProps>{
    constructor(props: IPaginationViewProps) {
        super(props);
    }
    
    renderOptions = () => {
        const { contentsLength } = this.props;
        const options = [
            <option key={0}>10</option>,
            <option key={1}>25</option>,
            <option key={2}>50</option>,
            <option key={3}>100</option>,
            <option key={4}>250</option>,
            <option key={5}>500</option>,
            <option key={6}>1000</option>
        ];

        if (contentsLength > 1000) {
            return options;
        }else if (contentsLength > 500) {
            return options.slice(0, 7);
        } else if (contentsLength > 250) {
            return options.slice(0, 6);
        } else if (contentsLength > 100) {
            return options.slice(0, 5);
        } else if (contentsLength > 50) {
            return options.slice(0, 4);
        } else if (contentsLength> 25) {
            return options.slice(0, 3);
        } else if (contentsLength > 10) {
            return options.slice(0,2);
        }

        return null;
    };

    changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        this.setPageNumber(this.props.currentPage, Number(event.target.value));
    };

    getNumberOfPages = () => {
        const { contentsLength, resultsPerPage } = this.props;
        return Math.ceil(contentsLength / resultsPerPage);
    };

    changePageNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
        const pageNumber = event.currentTarget.value;
        const { resultsPerPage } = this.props;
        this.setPageNumber(pageNumber, resultsPerPage);
    };

    setPageNumber = (newPageNumber: any, resultsPerPage: number) => {
        const { contentsLength, repertoireSection } = this.props;
        if (newPageNumber == "") {
            this.props.updateContentsTable(0, resultsPerPage, resultsPerPage, "", repertoireSection)
            return;
        }
        
        newPageNumber = Number(newPageNumber)
        if(!newPageNumber){
            return;
        }

        const numberOfPages = Math.ceil(contentsLength / resultsPerPage);

        if (newPageNumber >= numberOfPages) {
            newPageNumber = numberOfPages;
        }
        else if (newPageNumber < 1) {
            newPageNumber = 1
        }

        const indexOfLastResult = newPageNumber * resultsPerPage;
        const indexOfFirstResult = indexOfLastResult - resultsPerPage;
        this.props.updateContentsTable(indexOfFirstResult, indexOfLastResult, resultsPerPage, newPageNumber, repertoireSection);
    }

    increasePageNumber = () => {
        const { currentPage, resultsPerPage} = this.props;
        this.setPageNumber(currentPage + 1, resultsPerPage);
    };

    decreasePageNumber = () => {
        const { currentPage, resultsPerPage } = this.props;
        if (currentPage == "" || currentPage == 1) { return; }
        this.setPageNumber(currentPage - 1, resultsPerPage);
    };

    renderPageNumbers = () => {
        const { currentPage, paginationData } = this.props;
        const previous = paginationData?.find(f => f.name.toString() === "previous")?.data ?? "Prev";
        const next = paginationData?.find(f => f.name.toString() === "next")?.data ?? "Next";
        const of = paginationData?.find(f => f.name.toString() === "ofLabel")?.data ?? "of";
        return (
            <div className="pageNumberDiv">

                <div className="pageNumberButton" onClick={this.decreasePageNumber}>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" enableBackground="new 0 0 129 129" className="pageNumberPrevIcon"><g><path d="m40.4,121.3c-0.8,0.8-1.8,1.2-2.9,1.2s-2.1-0.4-2.9-1.2c-1.6-1.6-1.6-4.2 0-5.8l51-51-51-51c-1.6-1.6-1.6-4.2 0-5.8 1.6-1.6 4.2-1.6 5.8,0l53.9,53.9c1.6,1.6 1.6,4.2 0,5.8l-53.9,53.9z"></path></g></svg>
                    <div>{previous}</div>
                </div>
                <div className="inputDiv">
                    <input
                        className="pageNumberInput"
                        type={"text"}
                        value={currentPage}
                        onChange={this.changePageNumber}
                    />
                    {of} {this.getNumberOfPages()}
                </div>
                <div className="pageNumberButton" onClick={this.increasePageNumber}>
                    <div>{next}</div>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" enableBackground="new 0 0 129 129" className="pageNumberNextIcon"><g><path d="m40.4,121.3c-0.8,0.8-1.8,1.2-2.9,1.2s-2.1-0.4-2.9-1.2c-1.6-1.6-1.6-4.2 0-5.8l51-51-51-51c-1.6-1.6-1.6-4.2 0-5.8 1.6-1.6 4.2-1.6 5.8,0l53.9,53.9c1.6,1.6 1.6,4.2 0,5.8l-53.9,53.9z"></path></g></svg>

                </div>
            </div>
        );
    };

    renderResultsCountSection = () => {
        const { componentInstance, contentsLength, totalResults, paginationData, repertoireSection } = this.props;        
        if (componentInstance === "numbers") {
            return null;
        }

        if (componentInstance === DISTRIBUTION_POOLS_KEY) {
            const poolsLabel = 
                contentsLength === 1 
                    ? paginationData?.find(f => f.name.toString() === "singularPoolsLabel")?.data ?? "Pool"
                    : paginationData?.find(f => f.name.toString() === "poolsLabel")?.data ?? "Pools";

            return (  
                <div className="resultsNumberDiv">
                    {contentsLength} {poolsLabel}
                </div>
            );
        }

        if (repertoireSection === SEARCH_VIEW_ADJUSTMENTS) {
            const resultsLabel =
                contentsLength === 1
                    ? paginationData?.find(f => f.name.toString() === "singularResultsLabel")?.data ?? "Result"
                    : paginationData?.find(f => f.name.toString() === "resultsLabel")?.data ?? "Results";

            return (
                <div className="resultsNumberDiv">
                    {contentsLength} {resultsLabel}
                </div>
            );
        }

        if (!totalResults) {
            const resultsLabel = 
                contentsLength === 1 
                    ? paginationData?.find(f => f.name.toString() === "singularResultsLabel")?.data ?? "Result"
                    : paginationData?.find(f => f.name.toString() === "resultsLabel")?.data ?? "Results";

            return (  
                <div className="resultsNumberDiv">
                    {contentsLength} {resultsLabel}
                </div>
            );
        }

        const resultSetLabel = 
            paginationData?.find(f => f.name.toString() === "resultSetLabel")?.data ?? "Result Set:";
        const returnResultsLabel = 
            paginationData?.find(f => f.name.toString() === "returnResultsLabel")?.data ?? "Return Results:";

        return (
            <>
                <div className="resultsNumberDiv">
                    {resultSetLabel} {totalResults}
                </div>
                <div className="resultsNumberDiv">
                    {returnResultsLabel} {contentsLength}
                </div>
            </>
        )
    }

    render() {
        const { resultsPerPage, paginationData } = this.props;

        return (
            <div className="paginationDiv">
                <div className="showPerPageDiv">
                    {this.renderResultsCountSection()}
                    {this.renderOptions() !== null && (
                        <div>
                            { paginationData?.find(f => f.name.toString() === "showLabel")?.data ?? "Show" }
                            <select value={resultsPerPage}
                                onChange={event => this.changeResultsPerPage(event)}
                                className="resultsPerPageSelect"
                            >
                                {this.renderOptions()}
                            </select>
                            { paginationData?.find(f => f.name.toString() === "perPageLabel")?.data ?? "per page" }
                        </div>
                    )}
                </div>
                {this.getNumberOfPages() > 1 && <div>{this.renderPageNumbers()}</div>}
            </div>
        );
    }

}